import Alpine from "alpinejs"

Alpine.data("fullSearch", () => ({
    // available states
    state: {
        searching: false,
        result: false,
        empty: false,
    },

    // user input
    searchTerm: "",

    // async search result
    result: {},

    activeType: 'all',

    activeTypeResult: {
        total: 0,
        items: [],
    },

    init() {
        this.$watch("searchTerm", () => {
            if (this.searchTerm.length > 0) {
                this.setState("searching");
                // @todo debounce, but Alpine.debounce() is not working..?
                this.search();
            }
        });

        this.$watch("activeType", () => {
            this.activeTypeResult = this.result[this.activeType];
        });
    },

    setState(newState) {
        // check if newState does exist in this.state
        if (!Object.keys(this.state).includes(newState)) {
            return false;
        }

        // reset all states
        Object.keys(this.state).forEach((key) => {
            this.state[key] = false;
        });

        // set new state
        this.state[newState] = true;

        return true;
    },

    search() {
        if (document.body.classList.contains('preview-body') && this.$root.dataset.dummyresult) {
            this.dummyQuery();
        } else {
            this.query();
        }

        this.activeTypeResult = this.result[this.activeType];
    },
    dummyQuery() {
        setTimeout(() => {
            // @todo make actual search request
            if (this.searchTerm.length > 5) {

                let result = [];
                try {
                    result = JSON.parse(this.$root.dataset.dummyresult);
                } catch (e) {
                    // ignore...
                }

                this.result = result;
                this.setState("result");
            } else {
                this.result = {};
                this.setState("empty");
            }
        }, 500);

    },
    async query() {
        // dataset.uri may already carry its own query string (e.g.
        // entryPoint/excludeEntryPoint), so merge into it via URL/
        // URLSearchParams instead of blindly appending a new "?".
        const url = new URL(this.$root.dataset.uri, window.location.origin);
        url.searchParams.set("q", this.searchTerm);
        this.result = await (await fetch(url)).json();

        if (this.result.all.total > 0) {
            this.setState("result");
            this.activeType = '';
            this.activeType = 'all';
        } else {
            this.setState("empty");
        }
    }
}));
